module.exports = __webpack_public_path__ + "img/logo.95244819.png";